import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AddBroadcastAffiliation } from './Add';
import { BroadcastAffiliationDetail } from './Detail';
import { BroadcastAffiliationList } from './List';

export const BroadcastAffiliationsRoutes = ({ match }) => (
  <Switch>
    <Route exact path={match.url} component={BroadcastAffiliationList} />
    <Route path={`${match.url}/add`} component={AddBroadcastAffiliation} />
    <Route path={`${match.url}/:id`} component={BroadcastAffiliationDetail} />
  </Switch>
);
